import { render, staticRenderFns } from "./OutstandingComplianceNotice.vue?vue&type=template&id=87ed673c&scoped=true&"
import script from "./OutstandingComplianceNotice.vue?vue&type=script&lang=js&"
export * from "./OutstandingComplianceNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ed673c",
  null
  
)

export default component.exports